import { Controller } from "@hotwired/stimulus"
import { runConfetti } from "./confetti_animation"

export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.timeout = window.setTimeout(() => {
      runConfetti(this.element, {
        angle: 90,
        spread: 150,
        startVelocity: 40,
        elementCount: 100
      })
    }, 100)
  }

  disconnect() {
    if (this.timeout) window.clearTimeout(this.timeout)
  }
}
